"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { useFeatureStatus } from "@/app/context/FeatureStatusContext";
import type { GroupSwitchButtonItem } from "@/app/components/UI/GroupSwitchButton";
import ScrollSwitchTab from "@/app/components/UI/ScrollSwitchTab";
import { useRouter } from "@/app/hooks/useRouter";
type TradeModeTabsProps = {
  path: string;
};
type TradeModeTabItem = GroupSwitchButtonItem;
const TradeModeTabs = t0 => {
  const $ = _c(15);
  const {
    path
  } = t0;
  const router = useRouter();
  const featureStatus = useFeatureStatus();
  const isExactEnabled = featureStatus.exact;
  let t1;
  if ($[0] !== router) {
    t1 = route => {
      router.push(`/${route}`);
    };
    $[0] = router;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onNavigate = t1;
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      key: "/comparison",
      label: "\u0645\u0642\u0627\u06CC\u0633\u0647 \u0648 \u0645\u0639\u0627\u0645\u0644\u0647",
      className: "md:hidden"
    };
    t3 = {
      key: "/quick-order",
      label: "\u0645\u0639\u0627\u0645\u0644\u0647 \u0622\u0633\u0627\u0646"
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  const t4 = !isExactEnabled;
  let t5;
  if ($[4] !== isExactEnabled) {
    t5 = !isExactEnabled ? <span className="rounded-xl bg-crayola-300 px-2 py-1 text-xs text-white">به زودی</span> : null;
    $[4] = isExactEnabled;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t4 || $[7] !== t5) {
    t6 = [t2, t3, {
      key: "/limit-order",
      label: "\u0645\u0639\u0627\u0645\u0644\u0647 \u0628\u0627 \u0642\u06CC\u0645\u062A \u062F\u0644\u062E\u0648\u0627\u0647",
      disabled: t4,
      badge: t5
    }];
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const items = t6;
  let t7;
  if ($[9] !== onNavigate) {
    t7 = key => onNavigate(key.replace("/", ""));
    $[9] = onNavigate;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== items || $[12] !== path || $[13] !== t7) {
    t8 = <ScrollSwitchTab items={items} activeKey={path} onChange={t7} />;
    $[11] = items;
    $[12] = path;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
};
export default TradeModeTabs;